import { CampaignsBase, getEmailBroadcastMode } from './CampaignsBase';
import { Helper } from '../../../common/helpers/Helper';
import { ApiHelper } from '../../../common/helpers/ApiHelper';
import { AppConfig } from '../../../AppConfig';

export class Broadcasts extends CampaignsBase {
  constructor(props, options) {
    super(props, {
      ...options,
      pageTitle: Helper.getString('broadcasts'),
      pageKey: Broadcasts.pageKeyFromProps(props),
      campaignType: 'BROADCAST',
    });
  }

  static pageKeyFromProps(props) {
    const matchPath = (props.match && props.match.path) || (props.location && props.location.pathname) || ''
    return matchPath.includes('whatsapp-broadcasts') ? 'whatsapp-broadcasts' : 'broadcasts'
  }

  render() {
    this.pageKey = Broadcasts.pageKeyFromProps(this.props)
    return super.render()
  }

  async customSubmit(options) {
    const { formType, formData, caller } = options
    if (formType === 'add') {
      let paths = []
      if (this.formDefinition._subType === 'create-copy') {
        paths = ['miscs', 'create-copy']
      } else {
        paths = ['miscs', 'create-campaign']
      }
      const jsonBody = { ...formData }
      if (this.formDefinition._subType !== 'create-copy' && formData.channel === 'EMAIL') {
        const mode = getEmailBroadcastMode(this.orgId)
        const useSes = mode === 'NEW' || (mode === 'EXPERIMENTAL' && formData.broadcastMode === 'NEW')
        if (useSes) {
          jsonBody.__sesBroadcast = true
        }
      }
      ApiHelper.callAwait({
        ms: AppConfig.CDP_MS.ENDPOINT,
        method: 'POST',
        paths,
        queryParams: { orgId: this.orgId},
        jsonBody,
      }).then(response => {
        window.open(this.baseRoute() + `/campaigns/${response.id}`, '_self')
      }).catch(err => {
        const errorMessage = Helper.getErrorMsg(err)
        caller.setState({
          success: false,
          message: errorMessage,
          inProcess: false
        })
      })
      return
    }
    return caller.submit.call(caller, formData, true);
  }
}
